import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { api } from "@/lib/api";
import { usePermissions } from "@/contexts/PermissionsContext";

// Each tab is gated by a fine-grained permission `module`. If the current
// role's matrix has `<module>.view = false`, the tab is hidden.
const ALL_TABS = [
  { to: "heute", label: "Heute", testid: "tab-heute", module: "operations_heute" },
  { to: "zeiterfassung", label: "Zeiterfassung", testid: "tab-zeiterfassung", addon: "time_tracking", module: "operations_zeiterfassung" },
  { to: "auto-generator", label: "Auto-Generator", testid: "tab-auto-generator", addon: "time_tracking", badge: "NEU", module: "operations_auto_generator" },
  { to: "auto-generator-batch", label: "Massen-Lauf", testid: "tab-auto-generator-batch", addon: "time_tracking", module: "operations_massen_lauf" },
  { to: "auto-generator-overwrites", label: "Überschreib-Verlauf", testid: "tab-auto-generator-overwrites", addon: "time_tracking", module: "operations_ueberschreib_verlauf" },
  { to: "lenkprotokoll", label: "Lenkprotokoll", testid: "tab-lenkprotokoll", addon: "driving_logs", module: "operations_lenkprotokoll" },
  { to: "dienstplan", label: "Dienstplan", testid: "tab-dienstplan", module: "operations_dienstplan" },
  { to: "aufgaben", label: "Aufgaben", testid: "tab-aufgaben", module: "operations_aufgaben" },
  { to: "lenkerauskunft", label: "Lenkerauskünfte", testid: "tab-lenkerauskunft", addon: "driving_logs", module: "operations_lenkerauskunft" },
  { to: "buchhaltung", label: "Buchhaltung", testid: "tab-buchhaltung", module: "operations_buchhaltung" },
];

export default function OperationsNav() {
  const { can } = usePermissions();
  // Phase 2 Tier 3 — Add-on gated tabs (time_tracking, driving_logs)
  const [addons, setAddons] = useState(null);
  useEffect(() => {
    api.get("/extensions").then(({ data }) => {
      const s = new Set((data || []).filter(e => e.is_active).map(e => e.key));
      setAddons(s);
    }).catch(() => setAddons(new Set()));
  }, []);
  const TABS = ALL_TABS.filter(t => (!t.addon || !addons || addons.has(t.addon)) && can(t.module, "view"));

  return (
    <div className="flex flex-col h-full">
      <div className="px-6 md:px-8 pt-6">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Modul</div>
        <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-zinc-50 mt-1">Operations</h1>
      </div>
      <div className="px-6 md:px-8 border-b border-zinc-800 mt-5">
        <div className="flex gap-1">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={({ isActive }) =>
                `px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  isActive ? "text-zinc-50 border-blue-600" : "text-zinc-400 hover:text-zinc-200 border-transparent"
                }`
              }
            >
              {t.label}
              {t.badge && (
                <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded-full bg-amber-500/15 text-amber-300 text-[8px] font-bold uppercase tracking-wider border border-amber-500/30">
                  {t.badge}
                </span>
              )}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="flex-1"><Outlet /></div>
    </div>
  );
}
